import React, {Component,Fragment} from 'react';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import {Link, useParams} from 'react-router-dom';
import queryString from 'query-string';
import ReactTable from "react-table";
import checkboxHOC from "react-table/lib/hoc/selectTable";
import moment from "moment/moment";
import {currency_symbol, URL_VERSION, date_format} from '../../../server/constants'
import {_addNotification, _addNotificationError,getGradeIndexValue, isRegularLunchOrderType, 
    standardDateFormat,convertTwoDecimalPoint,getGradeIndex,isInt,getSchoolGrades, groupBy,} from '../../../server/util'

import {lunchTestdata,freeLunchTestdata,reducedLunchTestdata} from './lunchTestData'
import _ from 'lodash';
const CheckboxTable = checkboxHOC(ReactTable);

const CheckboxTable1 = checkboxHOC(ReactTable);
let cancelSelectedData={selectedRows:undefined,type:'single'}
let restoreSelectedData={selectedRows:undefined,type:'single'}
let gradeList=[{label:"All",value:"All"},
{label:"pk",value:"pk"},
{label:"k",value:"k"},
{label:"1",value:"1"},
{label:"2",value:"2"},
{label:"3",value:"3"},
{label:"4",value:"4"},
{label:"5",value:"5"},
{label:"6",value:"6"},
{label:"7",value:"7"},];
class lunchSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderedMenu: [],
            loading: false,
            students: [],
            data: [],
            columns: columns,
            historydata: [],
            event: [],
            history_Count: 0,
            //historycolumns: [],
            selection: [],
            selectionIds:[],
            selectAll: false,
            selectType: 'checkbox',
            tabIndex: 0,
            selectedIndex: 0,
            action: 'Ordered',
            filter: 'byStudents',
            replacedItem: '',
            cancelConformModal:false,
            cancelModal:false,
            restoreConformModal:false,
            restoreModal:false,
            restoreDate:new Date(),
            historyModal:false,
        };
       
        
        let columns = []
        columns.push({
            accessor: 'name',
            id:'name',
            Header: 'STUDENT NAME',
            style: {textAlign: 'center'},
            sortable:true,
            defaultSortDesc:true
        });
        columns.push({
            accessor: 'studentId',
            Header: 'STUDENT ID',
            style: {textAlign: 'center'}
        });
        
        if(this.state.action !== 'NotOrdered'){
        columns.push({
            id:'orderDateTime',
            Header: 'ORDER DATE',
            //Cell: props => <span>{new Date(props.original.orderDateTime).toLocaleString() }</span> ,
            Cell: props => <span>{moment(props.original.orderDateTime).format("YYYY/MM/DD")}</span>,
            style: {textAlign: 'center'},
            width: 200,
            sortable:true,
            defaultSortDesc:true
        })};

        if (this.state.action !== 'NotOrdered') {
            columns.push({
                accessor: 'orderPrice',
                Header: 'ORDER PRICE',
                width: 150,
                style: {textAlign: 'center'},
                Cell: ({row}) => (
                    <span style={{textAlign:'right'}}>
                    {'$ '+row._original.orderPrice} </span>),
                Footer: () => (
                    <span style={{textAlign:'right'}}>
                    {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */} 
                    Total Amount: {'$ '+convertTwoDecimalPoint(_.sumBy(this.state.data, (o)=> { return (o.orderPrice||0.00); }))}
                    </span>
                )
            });
            columns.push({
                accessor: 'totItems',
                Header: 'NO OF MEALS',
                style: {textAlign: 'center'},
            });
            if (this.state.action !== 'NotPaid') {
                columns.push({
                    accessor: 'payment',
                    Header: 'PAYMENT STATUS',
                    style: {textAlign: 'center'}
                });
            }
        }
    

       // }
       this.state.columns = columns
      
    };
    componentWillMount = () => {
        const parsed = queryString.parse(window.location.search);
        const type = parsed["type"];
        if(type === "free"){
            this.state.data = freeLunchTestdata
        }else if(type === "reduced"){
            this.state.data = reducedLunchTestdata
        }else{
            this.state.data = lunchTestdata
        }
    };
    render() {
        return (
            <div>
                <section>
                    <div className="container">
                        <div className="sectionTitle">
                            <h2>
                                <span>Manage Orders</span>
                            </h2>
                        </div>
                        <div className="row set-dashboard-center">
                        <Tabs>
                                        {/*// Todo: Might need to add tab index to select on redirect from chart*/}
                                        {/*selectedIndex={this.state.selectedIndex}
                                          onSelect={this.handleSelect}*/}
                                          <TabList>
                                              <div className="pull-right">
                                                  <lable style={{
                                                      padding: '12px',
                                                      fontWeight: '700',
                                                  }}>Total
                                                      {this.state.action === 'NotOrdered' ? " Students": " Orders"}: {this.state.data.length} </lable>
                                                  <div id="selector" className="btn-group pull-right"
                                                 style={{float: 'right', margin: '-7px'}}>

                                                <button type="button" className="btn btn-xs btn-inactive-color active"
                                                        id="Ordered"
                                                        style={{margin: 0, marginLeft: 5, fontSize: 14}}
                                                        onClick={() => {
                                                            this.getReportsData(this.state.tabIndex, 'Ordered');
                                                            this.setState({selectAll: false, selection: [],selectionIds:[]})
                                                        }}>Ordered
                                                </button>
                                                <button type="button" className="btn btn-xs btn-inactive-color"
                                                        style={{margin: 0, marginLeft: 5, fontSize: 14}} id="NotOrdered"
                                                        onClick={() => {
                                                            this.getReportsData(this.state.tabIndex, 'NotOrdered');
                                                            this.setState({selectAll: false, selection: [],selectionIds:[]})
                                                        }}>Not
                                                    Ordered
                                                </button>
                                               {/*  <button type="button" className="btn btn-xs btn-inactive-color"
                                                        style={{margin: 0, marginLeft: 5, fontSize: 14}} id="NotPaid"
                                                        onClick={() => {
                                                            this.getReportsData(this.state.tabIndex, 'NotPaid');
                                                            this.setState({selectAll: false, selection: [],selectionIds:[]})
                                                        }}>Not
                                                    Paid
                                                </button>
                                                <button type="button" className="btn btn-xs btn-inactive-color"
                                                        style={{margin: 0, marginLeft: 5, fontSize: 14}} id="Paid"
                                                        onClick={() => {
                                                            this.getReportsData(this.state.tabIndex, 'Paid');
                                                            this.setState({selectAll: false, selection: [],selectionIds:[]})
                                                        }}>Paid
                                                </button> */}

                                            </div>
                                              </div>
                                            <div className="button-group-section">
                                            </div>
                                            {gradeList.map((item)=> {
                                                return <Tab  onClick={() => {
                                                    this.state.tabIndex = item.value;
                                                    this.setState({selectAll: false})
                                                   
                                                }}>  {item.label}</Tab>
                                            }, this)}
                                        </TabList>
                                        <TabPanel>
                                            <div className="row">
                                                <div className="col-xs-6 pull-left">
                                                    <input type="text" id="search"
                                                           className="search form-control"
                                                           style={{
                                                               float: 'left',
                                                               margin: '5px 0'
                                                           }}
                                                           name="search"
                                                           placeholder="Search.."
                                                           onKeyUp={this.filterSchool}/>
                                                </div>

                                                {this.state.action === 'NotOrdered' || this.state.action === 'NotPaid' ? (
                                                    <div className="col-xs-6 pull-right button-group-section">
                                                        <button
                                                            className="btn btn-warning button-xs pull-right"

                                                            onClick={() => this.sendNotification('multiple')}
                                                            style={{
                                                                float: 'right',
                                                                margin: '5px'
                                                            }}>
                                                            <i className="fa fa-paper-plane-o"></i> Send
                                                            Reminder
                                                        </button>
                                                    </div>):null
                                                }
                                            </div>
                                            {this.state.action === 'NotOrdered' || this.state.action === 'NotPaid' ? (
                                                <CheckboxTable1
                                                    ref={r => (this.checkboxTable1 = r)}
                                                    data={_.orderBy(this.state.data,['name'],['desc'])}
                                                    columns={this.state.columns}
                                                    defaultPageSize={10}
                                                    className="-striped -highlight"
                                                    noDataText='No data found'

                                                />) : (<ReactTable
                                                data={this.state.data}
                                                columns={this.state.columns}
                                                defaultPageSize={10}
                                                className="-striped -highlight"
                                                noDataText='No data found'
                                               
                                                
                                            />)}
                                        </TabPanel>
                                        {gradeList.map(function (key) {
                                            return (
                                                <TabPanel>
                                                    <div className="row">
                                                        <div className="col-xs-6 pull-left">
                                                            <input type="text" id="search"
                                                                   className="search form-control"
                                                                   style={{
                                                                       float: 'left',
                                                                       margin: '5px 0'
                                                                   }}
                                                                   name="search"
                                                                   placeholder="Search.."
                                                                   onKeyUp={this.filterSchool}/>
                                                        </div>
                                                        {this.state.action === 'NotOrdered' || this.state.action === 'NotPaid' ? (
                                                            <div className="col-xs-6 pull-right button-group-section">
                                                                <button
                                                                    className="btn btn-warning button-xs pull-right"
                                                                    onClick={() => this.sendNotification('multiple')}
                                                                    style={{
                                                                        float: 'right',
                                                                        margin: '5px'
                                                                    }}>
                                                                    <i className="fa fa-paper-plane-o"></i> Send
                                                                    Reminder
                                                                </button>
                                                                {(this.state.action === 'NotPaid') ?
                                                                    this.CancelBtn('multiple',undefined)
                                                                    
                                                                :null}
                                                                
                                                            </div>) : 
                                                           (this.state.action === 'Ordered') ?
                                                           <div className="col-xs-6 pull-right"></div>
                                                            
                                                                :null 
                                                                
                                                        }

                                                    </div>
                                                    {this.state.action === 'NotOrdered' || this.state.action === 'NotPaid' ? (
                                                            <CheckboxTable1
                                                                ref={r => (this.checkboxTable1 = r)}
                                                                data={_.orderBy(this.state.data,['name'],['desc'])}
                                                                columns={this.state.columns}
                                                                defaultPageSize={10}
                                                                className="-striped -highlight"
                                                                noDataText='No data found'
                                                            />) :/* (<ReactTable
                                                        data={this.state.data}
                                                        columns={this.state.columns}
                                                        defaultPageSize={10}
                                                        className="-striped -highlight"
                                                        noDataText='No data found'
                                                        {...checkboxProps}
                                                    />) */

                                                    this.state.action==='Ordered'?
                                                    <CheckboxTable
                                                                ref={r => (this.checkboxTable = r)}
                                                                data={_.orderBy(this.state.data,['orderDateTime'],['desc'])}
                                                                columns={this.state.columns}
                                                                defaultPageSize={10}
                                                                className="-striped -highlight"
                                                                noDataText='No data found'
                                                                defaultSorting={[{
                                                                    id: 'orderDateTime',
                                                                    desc: false
                                                                    }]}
                                                                
                                                                
                                                            />
                                                    :
                                                        <ReactTable
                                                            data={_.orderBy(this.state.data,['orderDateTime'],['desc'])}
                                                            columns={this.state.columns}
                                                            defaultPageSize={10}
                                                            className="-striped -highlight"
                                                            noDataText='No data found'
                                                            sortable={true}
                                                            defaultSorting={[{
                                                                    id: 'orderDateTime',
                                                                    desc: false
                                                                    }]}
                                                            
                                                        />
                                                    }
                                                </TabPanel>)
                                        }, this)}
                                    </Tabs>
                        </div>

                    </div>
                </section>
            </div>

        );
    }
}

export default lunchSummary;




// WEBPACK FOOTER //
// ./src/components/District/Lunchs/lunchSummary.jsx